module.exports = __webpack_public_path__ + "img/bghe11.e6636eaa.png";